import React from 'react';

import { Texts as CommonTexts } from '../common';

export const Texts = () => {
  return <CommonTexts />;
};
